import { PropertyListItemDto } from '../dtos/property-list-item.dto.interface';
import { sortByStatus } from './property-status.util';

/** How a building's units are ordered on its tab */
export enum UnitSort {
  UNIT_NUMBER = 'Unit number',
  STATUS = 'Status',
  RENT = 'Rent',
}

/** "3A" before "10B": numbers inside a unit number compare as numbers, the rest as text */
const byUnitNumber = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

/** A unit's number, or its name when it has none */
export function unitLabel(unit: Pick<PropertyListItemDto, 'unitNumber' | 'displayName'>): string {
  return unit.unitNumber ? `Unit ${unit.unitNumber}` : unit.displayName;
}

export function sortUnits(units: PropertyListItemDto[], sort: UnitSort): PropertyListItemDto[] {
  switch (sort) {
    case UnitSort.STATUS:
      return sortByStatus(units);

    // Dearest first; a unit without a rent yet goes last
    case UnitSort.RENT:
      return [...units].sort((a, b) => (b.rent ?? -1) - (a.rent ?? -1));

    default:
      return [...units].sort((a, b) =>
        byUnitNumber.compare(a.unitNumber ?? a.displayName, b.unitNumber ?? b.displayName),
      );
  }
}
